export const DEFAULT_CONFIG = {
  // markdown?: string;
  ui: {
    name: "All Data International",
    // description?: string;
    cot: "full",
    // default_collapse_content?: boolean;
    // github?: string;
    theme: {
      default: "light",
      dark: {
        background: { default: "#1A2634", paper: "#34495E" },
        primary: {
          main: "#002F75",
          dark: "#27619C",
          light: "#D4E7F0",
        },
      },
    },
    // custom_css?: string;
    // custom_js?: string;
    // custom_font?: string;
    // custom_meta_image_url?: string;
  },
  features: {
    spontaneous_file_upload: {
      enabled: true,
      // max_size_mb: 5,
      max_files: 1,
      accept: [
        "application/pdf",
        "text/csv",
        "application/csv",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/plain",
      ],
    },
    audio: {
      enabled: false,
      min_decibels: -45,
      initial_silence_timeout: 3000,
      silence_timeout: 1500,
      chunk_duration: 1000,
      max_duration: 15000,
    },
    // unsafe_allow_html: true,
    // latex?: boolean;
    // edit_message?: boolean;
  },
  // debugUrl?: string;
  userEnv: [],
  dataPersistence: true,
  threadResumable: true,
  chatProfiles: [],
  starters: [
    // {
    //   label: "Morning routine ideation",
    //   message:
    //     "Can you help me create a personalized morning routine that would help increase my productivity throughout the day? Start by asking me about my current habits and what activities energize me in the morning.",
    //   // icon: "/public/idea.svg",
    // },
    // {
    //   label: "Explain superconductors",
    //   message: "Explain superconductors like I'm five years old.",
    //   // icon: "/public/learn.svg",
    // },
    // {
    //   label: "Python script for daily email reports",
    //   message:
    //     "Write a script to automate sending daily email reports in Python, and walk me through how I would set it up.",
    //   // icon: "/public/terminal.svg",
    // },
    // {
    //   label: "Text inviting friend to wedding",
    //   message:
    //     "Write a text asking a friend to be my plus-one at a wedding next month. I want to keep it super short and casual, and offer an out.",
    //   // icon: "/public/write.svg",
    // },
  ],
  translation: {},
};

export const DEFAULT_AUTH_CONFIG = {
  requireLogin: true,
  passwordAuth: true,
  headerAuth: false,
  oauthProviders: [],
};
